import { Department } from "@enums/department.enum";
import { IdType } from "@enums/idType.enum";
import { Shift } from "@enums/shift.enum";
import { Model } from "@interfaces/model.interface";
import { User } from "@interfaces/user.interface";

export interface UserProfile extends Model {
	address1: string;
	address2: string;
	currentDepartment: Department;
	currentWorkOrderStageId?: number
	dateOfBirth: Date;
	defaultDepartment: Department;
	defaultHolidayAllowance: number;
	email: string;
	emailAddressVerified: boolean;
	emergencyContactEmailAddress: string;
	emergencyContactName: string;
	emergencyContactPhoneNumber: string;
	emergencyContactRelation: string;
	firstName: string;
	fobId: string;
	fullName: string;
	gender: string;
	homeAddress: string;
	idIssuedDate?: Date;
	idNumber: string;
	idType?: IdType;
	idValidUntil?: Date;
	internalCost?: number;
	isActive: boolean;
	isConsultancyLead: boolean;
	isSupervisor: boolean;
	jobTitle: string;
	lastName: string;
	lastSeen: Date;
	markCompleted: boolean; // not a real field but used by super admins when creating new member details
	marketingConsent: boolean;
	personalEmailAddress: string;
	postcode: string;
	profileImage: string;
	shiftId: Shift;
	siteId: number;
	supervisorId: number;
	telephoneNumber: string;
	title: string;
	town: string;
	trackWorkload: boolean;
	user: User;
	userCode?: number;
	userId: number;
}

export class UserProfile implements UserProfile {
	address1 = "";
	address2 = "";
	currentDepartment = Department.BackOffice;
	dateOfBirth = new Date();
	defaultDepartment = Department.BackOffice;
	email = "";
	emailAddressVerified = false;
	firstName = "";
	gender = "";
	isActive = true;
	isConsultancyLead = false;
	isSupervisor = false;
	jobTitle = "";
	lastActivityAt = new Date();
	lastName = "";
	lastSeen = new Date();
	markCompleted = false;
	marketingConsent = false;
	postcode = "";
	profileImage = "";
	shiftId = Shift.Day;
	siteId = 1;
	telephoneNumber = "";
	title = "";
	town = "";
	trackWorkload = false;
	user: User = new User();

	constructor(data?: Partial<UserProfile>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}